function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffce00;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "Artboard 1");

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M31.84,461.24A22.11,22.11,0,0,1,12.7,428.08L230.8,50.32a22.11,22.11,0,0,1,38.29,0l218.1,377.76A22.11,22.11,0,0,1,468,461.24Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M270.55,387.76a20.61,20.61,0,1,1-20.61-20.61A20.61,20.61,0,0,1,270.55,387.76ZM249.94,168.48a31.94,31.94,0,0,0-31.15,39.43l15.35,127.5a15.81,15.81,0,0,0,31.61,0l15.35-127.5a31.94,31.94,0,0,0-31.16-39.43Z"
});

var SvgPending = function SvgPending(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    width: 15,
    height: 15,
    viewBox: "0 0 500 500",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPending, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/pending.250f6406.svg";
export { ForwardRef as ReactComponent };